import React from 'react'
import { useRouter } from 'next/router'

import { Button } from '@wartek-id/button-v1'
import { Dialog, DialogContent, DialogOverlay } from '@wartek-id/dialog-v1'
import { Text } from '@wartek-id/text-v1'
import { useToast } from '@wartek-id/toast'

import usePeriodContext from 'app/KinerjaShared/hooks/usePeriodContext'
import { PENGELOLAAN_KINERJA_PS_PEGAWAI_PATH } from 'app/KinerjaShared/constants/path'
import { SyncToEkin } from 'app/KinerjaPSPegawaiPage/components/SyncToEkin'
import { useAPIMulaiPelaksanaan } from 'api/kinerja/pengawas-sekolah/perencanaan'

type TDialogMulaiPelaksanaanConfirmationProps = {
  isOpen: boolean
  onClose: () => void
}
export const DialogMulaiPelaksanaanConfirmation: React.FC<
  TDialogMulaiPelaksanaanConfirmationProps
> = ({ isOpen, onClose }) => {
  const [error, setError] = React.useState<string | null>(null)

  const router = useRouter()
  const toast = useToast()
  const { period } = usePeriodContext()
  const { isLoading, mutateAsync } = useAPIMulaiPelaksanaan()

  const submit = async () => {
    try {
      setError(null)

      await mutateAsync({
        periodeId: period.id,
      })
      onClose()
      setTimeout(() => {
        router.push(PENGELOLAAN_KINERJA_PS_PEGAWAI_PATH)
      }, 500)
    } catch (e) {
      onClose()
      toast({
        message: 'Gagal mulai Pelaksanaan. Coba lagi.',
      })
    }
  }

  React.useEffect(() => {
    return () => {
      setError(null)
    }
  }, [isOpen])

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      autoFocus={false}
      returnFocus={false}
      size="sm"
    >
      <DialogOverlay />
      <DialogContent>
        <div className="p-6 space-y-8">
          <div className="space-y-3">
            <Text variant="display-sm">
              Sebelum mulai Pelaksanaan, pastikan Anda kirim data Perencanaan
              (SKP) ke E-Kinerja
            </Text>

            <Text color="subdued" variant="body-lg">
              Temukan kotak pengiriman di menu “Sebagai Pegawai”.
            </Text>

            <SyncToEkin perencanaanStatus="PELAKSANAAN_DIMULAI" isReadOnly />

            {Boolean(error) && (
              <Text color="critical" variant="body-sm">
                {error}
              </Text>
            )}

            <Button disabled={isLoading} isLoading={isLoading} onClick={submit}>
              Saya mengerti
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
